var render, staticRenderFns
import script from "./TimelineLink.vue?vue&type=script&lang=js&"
export * from "./TimelineLink.vue?vue&type=script&lang=js&"
import style0 from "./TimelineLink.vue?vue&type=style&index=0&id=6b52d8f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b52d8f2",
  null
  
)

export default component.exports